// extracted by mini-css-extract-plugin
export default {"gradeDisplay":"GradeDisplay_gradeDisplay__E3p2H","small":"GradeDisplay_small__GPukY","medium":"GradeDisplay_medium__dcD1P","large":"GradeDisplay_large__N2NQk"};